import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Avatar, Space} from 'antd';
import {
  StyledTransactionDetailsHeader,
  StyledTransactionDetailsHeaderDate,
  StyledTransactionDetailsHeaderItem,
  StyledTransactionDetailsHeaderPrice,
  StyledTransactionDetailsHeaderTitle,
} from './StyledTransactionDetailsHeader';
import {ExternalLinkIcon} from '../../../../icons';
import {
  amountHelpers,
  dateHelpers,
  objectHelpers,
  systemHelpers,
  textHelpers,
  transactionsHelpers
} from '../../../../utils/helpers';
import routes from '../../../../routes/routes.json';
import {firebaseEvents} from '../../../../snippets/firebase';

const gObjProp = objectHelpers.getObjProp;

const TransactionDetailsHeader = ({
  availableSubscriptionLink = true,
  subscriptionLink,
  subscription,
  transaction,
  ...rest
}) => {
  const getTransactionProp = (propName, defaultValue) => gObjProp(transaction, propName, defaultValue);
  const getSubscriptionProp = (propName, defaultValue) => gObjProp(subscription, propName, defaultValue);

  const amount = getTransactionProp('amount');
  const isPositiveAmount = Boolean(parseFloat(amount));
  const isIncoming = getTransactionProp('is_incoming', false);
  const date = dateHelpers.getDateFromISO(getTransactionProp('created_date'), 'DD MMM YYYY, HH:mm');
  const source = transactionsHelpers.getTransactionSource(transaction);
  const subscriptionId = getSubscriptionProp('id');
  const isReturnedTransaction = transactionsHelpers.isReturnedTransaction(transaction);

  const getTitle = () => {
    const service = getSubscriptionProp('service');
    const serviceLogo = gObjProp(service, 'logo');
    const serviceName = gObjProp(service, 'name') || gObjProp(service, 'url');
    const initials = textHelpers.getInitials(serviceName || source);

    return (
      <Space size={subscriptionId ? 4 : 'small'}>
        <Avatar src={serviceLogo} size={36}>
          {initials}
        </Avatar>
        {(availableSubscriptionLink && subscriptionId) ? (
          <Link
            onClick={() => systemHelpers.logEvent(firebaseEvents.TRANSACTIONS_NAVIGATE_TO_SUBSCRIPTION_PAGE_FROM_TRANSACTION_DETAILS)}
            to={`${routes.subscriptionsList}/${subscriptionId}`}
          >
            <Space size={12}>
              <StyledTransactionDetailsHeaderTitle>{source}</StyledTransactionDetailsHeaderTitle>
              <ExternalLinkIcon />
            </Space>
          </Link>
        ) : <StyledTransactionDetailsHeaderTitle>{source}</StyledTransactionDetailsHeaderTitle>}
      </Space>
    );
  }

  const title = getTitle();

  return (
    <StyledTransactionDetailsHeader {...rest}>
      <StyledTransactionDetailsHeaderItem>
        {title}
        <Space size={0} direction='vertical' align='end'>
          <StyledTransactionDetailsHeaderPrice className={`${isReturnedTransaction ? 'returned' : ''}`}>
            {(!isIncoming && isPositiveAmount) && '-'}{amountHelpers.getAmountWithCurrencyCode(amount)}
          </StyledTransactionDetailsHeaderPrice>
          <StyledTransactionDetailsHeaderDate>{date}</StyledTransactionDetailsHeaderDate>
        </Space>
      </StyledTransactionDetailsHeaderItem>
    </StyledTransactionDetailsHeader>
  );
}

TransactionDetailsHeader.propTypes = {
  availableSubscriptionLink: PropTypes.bool,
  subscription: PropTypes.object,
  transaction: PropTypes.object
}

export default TransactionDetailsHeader;
